export function isHotelWifiEnabled(
  config: Record<string, unknown> | null | undefined
): boolean {
  return config?.hotelWifi === true;
}

export function isAiConciergeEnabled(
  config: Record<string, unknown> | null | undefined
): boolean {
  return config?.aiConciergeEnabled === true;
}
